module.exports = __webpack_public_path__ + "img/a_tool_6.1800e1bc.png";